import React from 'react'

// styles
import * as SC from './VisuallyHiddenStyles'

type Props = React.ComponentPropsWithoutRef<'span'> & {
	as?: React.ElementType
}

const VisuallyHidden = (props: Props) => {
	const { children, ...rest } = props

	return <SC.VisuallyHidden {...rest}>{children}</SC.VisuallyHidden>
}

export default VisuallyHidden
